import $ from 'jquery';

class User {

  constructor() {}

  init() {
    this.$userForm = $('div#user-form');
    if (this.$userForm.length === 0) return;

    this.use_default_signature = this.$userForm.find('#use_default_signature')[0];

    this.setupInitialAuthLevelValidationMessages();
    this.setEmailSignature();
  }

  setupEvents() {
    this.$userForm = $('div#user-form');
    if (this.$userForm.length === 0) return;

    let _this = this;

    this.setupUpdatedAuthLevelValidationMessages();

    this.use_default_signature.addEventListener('change', function () {
      _this.setEmailSignature();
    });
  };

  /**
   * This is required to update HTML validation messages for already populated fields.
   * When page loads with populated data and user submits form without any changes.
   */
  setupInitialAuthLevelValidationMessages() {
    this.$userForm.find('input.authority-level')
      .each((index, element) => this.setAuthLevelValidationMessages(element));
  }

  /**
   * This is required to update HTML validation messages when field data was updated.
   * Element.validity may change and initial setup will not work here.
   */
  setupUpdatedAuthLevelValidationMessages() {
    this.$userForm.find('input.authority-level')
      .on('input', e => this.setAuthLevelValidationMessages(e.target));
  }

  setAuthLevelValidationMessages(element) {
    const type = element.dataset.type || 'payment';
    const max = element.getAttribute('max') || 0;
    const message = "The user's " + type + " authority level cannot exceed" +
      " the client's default authority level, which is currently set at " + max + ".";
    if (element.validity.rangeOverflow) {
      element.setCustomValidity(message);
    } else {
      element.setCustomValidity("");
    }
  }

  /**
   * Show default email signature template as a preview or rich editor filled with the default template to edit.
   */
  setEmailSignature() {
    const defaultSignature = this.$userForm.find('#default_signature');
    const userSignature = this.$userForm.find('#user_signature');

    if (this.use_default_signature.checked) {
      defaultSignature.removeClass('d-none');
      userSignature.addClass('d-none');
    } else {
      userSignature.removeClass('d-none');
      defaultSignature.addClass('d-none');
    }
  }

  load() {
    this.init();
    this.setupEvents();
  }
}

export default new User();
